/** Filled dart pointing up (north). The panel compass rotates this to downwind. */
export function windVaneSvg(uid: string): string {
  return `<svg class="wind-vane" viewBox="0 0 64 120" aria-hidden="true">
    <defs>
      <linearGradient id="${uid}-shaft" x1="32" y1="120" x2="32" y2="0">
        <stop offset="0" stop-color="#4aa7d4" stop-opacity="0.2"/>
        <stop offset="0.45" stop-color="#7ec8ff"/>
        <stop offset="1" stop-color="#e7f7ff"/>
      </linearGradient>
      <filter id="${uid}-glow" x="-40%" y="-40%" width="180%" height="180%">
        <feGaussianBlur stdDeviation="2.2" result="b"/>
        <feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge>
      </filter>
    </defs>
    <path filter="url(#${uid}-glow)" fill="url(#${uid}-shaft)" stroke="#d7f2ff" stroke-width="1.6" stroke-linejoin="round"
      d="M32 6 L54 48 L40 44 L40 112 L24 112 L24 44 L10 48 Z"/>
  </svg>`;
}
